module.exports = require("lodash/sample");


//////////////////
// WEBPACK FOOTER
// external "lodash/sample"
// module id = 71
// module chunks = 0